import * as React from 'react'
import { SVGProps } from 'react'
const SvgPuzzle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 60 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1118_6368)">
      <path
        d="M14.3378 16.5214L11.7416 26.1227C11.7416 26.1227 8.75357 23.01 6.70691 26.5193C5.13374 29.2173 8.20142 31.3599 10.2471 30.566L8.8312 35.724L13.3939 36.9934C13.3939 36.9934 9.78328 41.123 14.8098 42.4686C17.7942 43.2677 17.4847 38.1046 17.4847 38.1046L26.6893 40.8819C26.6893 40.8819 27.0826 37.1525 30.1508 37.7872C33.268 38.4322 31.4885 42.0719 31.4885 42.0719L36.1299 43.5L39.7487 29.2966L34.6348 27.8686C34.6348 27.8686 35.0281 32.2326 31.8026 31.9153C27.79 31.5207 30.0721 26.5193 30.0721 26.5193L25.9027 25.488L27.3186 20.33C27.3186 20.33 30.989 22.4495 31.7239 19.2987C32.6679 15.252 28.1838 16.3627 28.1838 16.3627L29.5215 11.2841L24.8801 10.0941C24.8801 10.0941 28.0949 5.81502 24.4868 4.69812C20.747 3.54052 20.3174 7.79277 20.868 8.74481L17.0132 7.71343L15.912 11.2841C15.912 11.2841 19.7668 12.3155 18.9802 14.9341C18.0133 18.1524 14.3388 16.5208 14.3388 16.5208"
        fill="#ED5E11"
      />
      <path
        d="M20.9357 39.1453L26.6895 40.8815C26.6895 40.8815 27.0828 37.1521 30.151 37.7868C33.2682 38.4318 31.4882 42.0715 31.4882 42.0715L36.1296 43.4996L39.7484 29.2962L34.6345 27.8682C34.6345 27.8682 35.0278 32.2322 31.8023 31.9149C27.7897 31.5202 30.0718 26.5189 30.0718 26.5189L25.9024 25.4875L17.7612 31.2647L20.9352 39.1448L20.9357 39.1453Z"
        fill="#004E60"
      />
      <path
        d="M19.845 18.8222C15.9115 18.1082 16.6981 22.8689 16.6981 22.8689L12.8862 21.8901L11.7421 26.1223C11.7421 26.1223 8.71016 22.9838 6.70691 26.5189C5.13374 29.2962 8.20142 31.359 10.2471 30.5656L8.8312 35.723L13.3939 36.9924C13.3939 36.9924 9.41808 41.5955 14.8098 42.4677C18.0394 42.9901 17.4847 38.1037 17.4847 38.1037L21.9708 39.457L23.3851 34.7705C23.3851 34.7705 19.5303 34.5325 20.3956 31.4378C21.2608 28.3432 24.7223 29.6924 24.7223 29.6924L25.9022 25.4871L20.4737 23.9797C21.1816 23.6623 24.0517 19.5857 19.8444 18.8217"
        fill="#C3FF34"
      />
      <path
        d="M36.1401 28.2886C36.1412 29.0922 36.4578 29.8944 37.0141 30.4709C37.5836 31.0607 38.3942 31.4028 39.2099 31.4105L39.7487 29.2963L36.1401 28.2886Z"
        fill="#112231"
      />
      <path
        d="M38.6862 8.93335L36.3499 14.2912C36.3499 14.2912 42.2462 13.9985 40.5311 18.4903C39.3634 21.5479 35.0331 19.6536 34.6664 17.8186L32.6064 22.3341L39.3548 25.2144C38.5426 25.3396 34.7655 29.8834 39.4906 31.6443C42.9649 32.9384 44.2464 28.8732 43.5431 27.6517L48.1089 29.6619L54.5538 15.3514L48.6186 12.9069C48.6186 12.9069 48.874 17.9494 45.0555 16.8083C41.3524 15.7022 44.2536 11.1656 44.2536 11.1656L38.6862 8.93335Z"
        fill="#FFA9DF"
      />
      <path
        d="M54.164 34.8054C52.9443 35.5246 52.5699 36.0804 52.0683 37.9227C51.6934 36.118 51.3573 35.5926 50.1836 34.9769C51.4038 34.2578 51.7777 33.7014 52.2793 31.8596C52.6537 33.6643 52.9903 34.1898 54.164 34.8054Z"
        fill="#C3FF34"
      />
      <path
        d="M8.71019 14.708C7.73003 15.2861 7.42918 15.7327 7.02618 17.2133C6.72483 15.7631 6.45462 15.3407 5.51123 14.8461C6.49191 14.2681 6.79224 13.8214 7.19524 12.3408C7.49608 13.791 7.7668 14.2135 8.70968 14.708"
        fill="#BBF6E2"
      />
      <path
        d="M23.1582 35.5225L23.385 34.7714C23.385 34.7714 23.3063 34.7668 23.1751 34.7493C23.1715 35.0074 23.1659 35.265 23.1582 35.5225Z"
        fill="#BBF6E2"
      />
      <path
        d="M23.3982 25.4622C23.27 25.1778 23.1122 24.9094 22.9283 24.6616L20.474 23.98C20.6288 23.9105 20.8873 23.6617 21.1523 23.3062C19.2099 22.5489 17.1167 23.1702 15.4445 24.3211C14.5889 24.9099 13.7942 25.591 13.0597 26.3339C12.7267 25.9732 12.3497 25.6621 11.9283 25.4313L11.7414 26.1226C11.7414 26.1226 10.9977 25.3535 10.0043 25.0057C8.49698 25.1206 7.2885 26.2623 6.66894 27.6671C6.53869 27.9623 6.42785 28.2642 6.33643 28.5718C6.47536 29.1673 6.83443 29.6706 7.30791 30.0421C7.42743 28.8201 7.87844 27.595 8.79629 26.7918C8.89385 26.7063 8.9674 26.6507 9.12983 26.5528C9.20185 26.5095 9.2754 26.4709 9.34997 26.4328C9.35712 26.4292 9.39645 26.4111 9.40564 26.406C9.44344 26.391 9.48174 26.3771 9.52005 26.3637C9.88832 26.2375 10.1018 26.2102 10.5033 26.2535C10.5722 26.2607 10.8516 26.3266 10.9931 26.3766C11.1218 26.4214 11.2848 26.5023 11.4462 26.6018C11.7337 26.7785 11.9728 26.9917 12.2088 27.2529C11.7961 27.7259 11.4043 28.2163 11.0345 28.7181C10.5656 29.3533 10.1355 30.0168 9.74429 30.7031C9.91642 30.6752 10.085 30.6299 10.2474 30.567L8.83153 35.725L8.96434 35.7621C9.42046 34.1336 10.0865 32.5731 10.9431 31.1162C11.5299 30.1183 12.2021 29.1761 12.9519 28.3008C13.6159 29.5027 13.9198 30.9725 14.0312 32.3186C14.1977 34.3366 13.9014 36.3731 13.1445 38.2503C12.8651 38.9427 12.4927 39.6032 11.9835 40.1467C11.9855 40.599 12.1163 41.0395 12.4519 41.4202C12.5484 41.3399 12.6409 41.2554 12.7297 41.1688C13.0704 40.836 13.3575 40.4635 13.6062 40.0658C13.5327 40.4955 13.4841 40.9298 13.4663 41.3672C13.4561 41.6139 13.4576 41.8612 13.4704 42.1085C13.8177 42.2533 14.237 42.3723 14.7401 42.4583C14.5353 40.7309 15.0481 38.9355 15.7372 37.374C16.4747 35.7038 17.4487 34.1382 18.5842 32.7148C19.8611 31.1142 21.3112 29.6706 22.8481 28.3245C22.8936 28.6836 22.9283 29.0442 22.96 29.4043C23.4396 29.3894 23.887 29.4646 24.2119 29.5424C24.1817 29.2204 24.149 28.8984 24.1128 28.5769C24.0678 28.1777 24.0188 27.7794 23.9514 27.3853C24.5536 26.8866 25.1655 26.3998 25.782 25.9222L25.9035 25.4895L24.7308 25.1639C24.3595 25.4534 23.9907 25.7466 23.625 26.0433C23.5596 25.848 23.485 25.6549 23.3992 25.4642M19.0041 30.3167C17.6449 31.7952 16.4144 33.4124 15.4409 35.1763C15.3311 35.3757 15.2233 35.5776 15.1186 35.7811C15.1416 35.6415 15.1625 35.5019 15.1814 35.3618C15.4746 33.1949 15.3071 30.8921 14.5379 28.835C14.3519 28.3379 14.1134 27.8294 13.8207 27.3513C14.0164 27.1514 14.2156 26.9552 14.4199 26.764C15.7234 25.542 17.3517 24.2742 19.1782 24.2186C19.973 24.1943 20.7846 24.3731 21.4297 24.8764C22.0544 25.3643 22.392 26.1335 22.5891 26.9021C21.3316 27.9711 20.1242 29.0978 19.0046 30.3156"
        fill="#BBF6E2"
      />
      <path
        d="M9.99182 25.0006C9.73337 24.9115 9.45806 24.8507 9.17407 24.8398L9.15723 25.9681C9.33804 25.6533 9.65113 25.2829 9.99131 25.0006"
        fill="#112231"
      />
      <g filter="url(#filter0_d_1118_6368)">
        <path
          d="M12.2128 21.6695C10.4292 22.671 9.88212 23.4458 9.14916 26.0119C8.6011 23.4989 8.10923 22.7663 6.39355 21.9086C8.17768 20.9071 8.7242 20.1322 9.45716 17.5662C10.0047 20.0797 10.4966 20.8118 12.2128 21.6695Z"
          fill="white"
        />
      </g>
      <path
        d="M43.381 24.1002C43.381 22.1384 41.8042 20.5486 39.8597 20.5486C38.7764 20.5486 37.808 21.0421 37.1619 21.818C36.7829 21.6778 36.3737 21.6006 35.9467 21.6006C34.9548 21.6006 34.0594 22.0148 33.4194 22.6804L39.3556 25.2145C38.8857 25.2872 37.4228 26.8389 37.1894 28.475C37.7594 28.2576 38.2595 27.897 38.6446 27.4344C39.0231 27.5745 39.4327 27.6518 39.8597 27.6518C41.8047 27.6518 43.381 26.0615 43.381 24.1002Z"
        fill="#FF945A"
      />
      <path
        d="M44.5332 16.6095C41.8072 15.3195 43.981 11.6107 44.2308 11.2032C44.1838 11.1672 44.1353 11.1327 44.0857 11.0987L42.6637 10.5284C42.0544 10.43 41.4353 10.4959 40.8684 10.7102C40.6069 10.4001 40.2876 10.1306 39.9158 9.91891C39.4505 9.65462 38.9515 9.50883 38.4519 9.4707L36.3501 14.2912C36.3501 14.2912 41.1866 14.0511 40.8245 17.3426C42.1075 17.85 43.5561 17.5466 44.5326 16.6095"
        fill="#FF945A"
      />
      <path
        d="M52.4269 17.5562C50.8634 16.3899 48.6584 16.7227 47.5016 18.2996C46.8575 19.178 46.6751 20.2568 46.9096 21.2423C46.5725 21.4659 46.2675 21.7523 46.0137 22.0985C44.8573 23.6755 45.1873 25.8995 46.7507 27.0664C47.4163 27.563 48.1988 27.7871 48.9664 27.7598L53.2028 18.3537C52.9928 18.056 52.7344 17.786 52.4274 17.5568"
        fill="#FF945A"
      />
      <path
        d="M43.0705 30.6119C41.9636 30.5001 40.8307 30.9205 40.0615 31.8138C41.4804 32.127 42.478 31.4944 43.0705 30.6119Z"
        fill="#FF945A"
      />
      <path
        d="M48.7158 12.947C48.9544 13.3952 49.292 13.7991 49.7241 14.1216C50.6624 14.8218 51.831 14.981 52.8663 14.6564L48.7158 12.9465V12.947Z"
        fill="#FF945A"
      />
      <path
        d="M45.9575 28.7145C46.8248 29.0963 47.4127 29.3554 47.6982 29.4806L47.6109 26.9058C47.3203 27.694 46.7073 28.3493 45.958 28.7145"
        fill="#112231"
      />
      <g filter="url(#filter1_d_1118_6368)">
        <path
          d="M50.4703 31.2436C48.6616 32.3095 48.107 33.1343 47.3633 35.8657C46.8076 33.1904 46.309 32.411 44.5688 31.4981C46.378 30.4322 46.9322 29.6074 47.6759 26.8765C48.2311 29.5518 48.7301 30.3312 50.4703 31.2441"
          fill="white"
        />
      </g>
      <path
        d="M20.767 15.444C20.8319 15.9185 21.1312 16.3487 21.5352 16.5949C21.9495 16.8474 22.4704 16.8798 22.9179 16.698C23.1743 16.5934 23.4057 16.4321 23.5778 16.2116C23.6309 16.1436 23.6437 16.0514 23.5778 15.985C23.5226 15.9293 23.4067 15.9164 23.3531 15.985C23.1043 16.3033 22.7217 16.4934 22.3187 16.4939C21.93 16.4939 21.5648 16.2982 21.3304 15.988C21.191 15.8036 21.1052 15.5883 21.0735 15.359C21.0617 15.273 20.9529 15.2261 20.8784 15.2472C20.7864 15.2725 20.7558 15.3585 20.7675 15.4445"
        fill="#112231"
      />
      <path
        d="M21.7581 14.3932C21.9624 14.3932 21.9629 14.0728 21.7581 14.0728C21.5533 14.0728 21.5533 14.3932 21.7581 14.3932Z"
        fill="#112231"
      />
      <path
        d="M23.3509 14.8085C23.5552 14.8085 23.5557 14.488 23.3509 14.488C23.1461 14.488 23.1461 14.8085 23.3509 14.8085Z"
        fill="#112231"
      />
      <path
        d="M29.08 34.3942C29.1449 34.8687 29.4442 35.2989 29.8482 35.5451C30.2624 35.7975 30.7834 35.83 31.2309 35.6481C31.4873 35.5436 31.7186 35.3823 31.8908 35.1618C31.9439 35.0938 31.9567 35.0016 31.8908 34.9351C31.8356 34.8795 31.7197 34.8666 31.666 34.9351C31.4173 35.2535 31.0347 35.4436 30.6317 35.4441C30.243 35.4441 29.8778 35.2484 29.6434 34.9382C29.5039 34.7538 29.4181 34.5385 29.3865 34.3092C29.3747 34.2232 29.2659 34.1763 29.1909 34.1974C29.0994 34.2227 29.0683 34.3087 29.08 34.3947"
        fill="#112231"
      />
      <path
        d="M30.0711 33.3434C30.2754 33.3434 30.2759 33.0229 30.0711 33.0229C29.8663 33.0229 29.8663 33.3434 30.0711 33.3434Z"
        fill="#112231"
      />
      <path
        d="M31.6639 33.7587C31.8682 33.7587 31.8687 33.4382 31.6639 33.4382C31.459 33.4382 31.459 33.7587 31.6639 33.7587Z"
        fill="#112231"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1118_6368"
        x="6.39355"
        y="17.5662"
        width="5.81934"
        height="9.4458"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1118_6368"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1118_6368"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1118_6368"
        x="44.5688"
        y="26.8765"
        width="5.90137"
        height="9.98926"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1118_6368"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1118_6368"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1118_6368">
        <rect
          width="58"
          height="39"
          fill="white"
          transform="translate(1 4.5)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default SvgPuzzle
